import { Component, OnInit, inject } from '@angular/core';
import { MeService } from '../../../core/services/me.service';
import { NgForm, FormsModule } from '@angular/forms';
import { supportEmailAddress } from '../../../core/constants';


@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    imports: [FormsModule]
})
export class ForgotPasswordComponent implements OnInit {
  private meService = inject(MeService);

  supportEmailAddress = supportEmailAddress;
  email: string = null;
  submitted = false;

  ngOnInit() {}

  onSubmit(forgotPasswordForm: NgForm) {
    if (forgotPasswordForm.valid) {
      this.meService.resetPassword(this.email).subscribe(_resp => {
        this.submitted = true;
      });
    }
  }
}
